import React from 'react'
import Tab from './Tab';

type TabGroupProps = {
    tabs: { label: string; isDisabled?: boolean }[];
    activeTabIndex: number;
    onTabClick: (index: number) => void;
}

const TabGroup: React.FC<TabGroupProps> = ({ tabs, activeTabIndex, onTabClick }) => {
    return (
        <div className="tw-flex tw-gap-10 tw-justify-evenly tw-border-b tw-border-[#97A0AF] tw-bg-white tw-sticky tw-top-[100px] tw-z-10">
            {tabs.map((tab, index) => (
                <Tab
                    key={index}
                    label={tab.label}
                    isActive={index === activeTabIndex}
                    isDisabled={tab.isDisabled}
                    onClick={() => onTabClick(index)}
                />
            ))}
        </div>
    );
};

export default TabGroup;